const URL = {
  SEND_CONFIRMATION_EMAIL: 'Auth/SendConfirmationEmail',
  CONFIRM_CODE: 'Auth/ConfirmActivationCode',
  SIGN_UP: 'Auth/Register',
  SIGN_UP_ROOTIE: 'Registration/SignUpRootie',
  REGISTER_MARKETING_INFO: 'Auth/RegisterMarketingInfo',
  ADD_TO_MAIN_SUBSCRIPTION_GROUP: 'Auth/AddToMainSubscriptionGroup',
}

export default URL
